// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"179":"main","1216":"vendors"}[chunkId] + "." + {"179":"80c18f2e","1216":"9ef8d770"}[chunkId] + ".css";
};